const ENDPOINT = "https://api.web3forms.com/submit";

export async function sendForm(subject: string, form: HTMLFormElement) {
  const access_key = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
  if (!access_key) throw new Error("Form is not configured.");
  const data = Object.fromEntries(new FormData(form).entries());
  if (data.botcheck) return;
  const res = await fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ ...data, access_key, subject, from_name: data.name, botcheck: "" }),
  });
  const json = await res.json().catch(() => ({})) as { success?: boolean; message?: string };
  if (!res.ok || !json.success) throw new Error(json.message || "Could not send. Please email warmnestcounselling@gmail.com.");
}
